app.filter('renderDetailError', function () {
  return function (error) {
    let result = '<strong>' + error.errorMessage + '</strong>';

    if (error.detailMessage != null && error.detailMessage != '') {
      result += ' ' + error.detailMessage;
    }

    return result;
  };
});
